import { connect } from 'react-redux';

import { RootState } from '../../../../reducers';
import FileInput from '../../FileInput/FileInput';
import UploadedFilesStatus from '../../FileUpload/UploadedFilesStatus';
import MissingRequiredDocWarning from '../../MissingRequiredDocWarning/MissingRequiredDocWarning';
import { useDocPresentStatus } from '../../MissingRequiredDocWarning/MissingRequiredDocWarning.hook';
import { documentTypes } from '../../TradingHistory.helpers';
import thstyles from '../../TradingHistory.module.css';
import styles from '../OptionalStatement.module.css';

const mapStateToProps = (state: RootState) => {
    return {
        missingDocs: state?.tradingHistory?.missing
    };
};

const BusinessPlan = ({
    isOptional,
    missingDocs
}: {
    isOptional: boolean;
    missingDocs: [];
}) => {
    const isBusinessPlanMissing = useDocPresentStatus(
        missingDocs,
        'business_plan'
    );
    return (
        <>
            <div className={thstyles.headerSection}>
                <h3 className={thstyles.title}>Business Plan</h3>
                {isBusinessPlanMissing && (
                    <MissingRequiredDocWarning dataTestId="business-plan-warning" />
                )}
            </div>
            <div
                className={styles.CurrentManagementSection}
                data-testid="business-plan">
                <div className={styles.descriptionContainer}>
                    <p>Include information on:</p>
                    <ul>
                        <li>The business you are proposing</li>
                        <li>How you plan on generating revenue</li>
                        <li>The size of investment you need</li>
                        <li>How the funds will be used</li>
                        <li>Details of your experience in the industry</li>
                    </ul>
                </div>
                <FileInput
                    documentType={documentTypes.business_plan}
                    buttonText="Upload plans"
                    isOptional={isOptional}
                />
            </div>
            <UploadedFilesStatus documentType={documentTypes.business_plan} />
        </>
    );
};

export default connect(mapStateToProps)(BusinessPlan);
